import { createSlice } from '@reduxjs/toolkit';

import { ROUTES } from '@app/store';
import { ROUTES_INITIAL_STATE } from '@app/store/reducers/routesReducer/routes.state';

import type { PayloadAction } from '@reduxjs/toolkit';

const routesSlice = createSlice({
  name: ROUTES,
  initialState: ROUTES_INITIAL_STATE,
  reducers: {
    setRoutes: (state, { payload }: PayloadAction<{ data: string[] }>) => {
      const { data } = payload;
      state.allSessionRoutes = data;
    },
  },
});

export const { setRoutes } = routesSlice.actions;
export const routesReducer = routesSlice.reducer;
